import { twMerge } from "tailwind-merge";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
  ref?: React.ForwardedRef<HTMLTextAreaElement>;
}

const Textarea = ({ className, error, ref, ...props }: TextareaProps) => {
  return (
    <textarea
      className={twMerge(
        "placeholder:text-grey-400 border-grey-300 ring-grey-200/70 focus:border-grey-300 shadow-xs flex min-h-20 w-full items-stretch rounded-lg border bg-white px-3.5 py-2.5 outline-hidden transition-all focus:ring-3",
        error === true &&
          "border-error-300 focus:border-error-300 ring-error-200/70",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
};
Textarea.displayName = "Textarea";

export { Textarea };
